export default ["png", "jpg", "jpeg"];
